import { accessRole } from "../../../../helpers/access_role"
import apiResponse from '../../../../services/apiResponse'
import React, { Component, Fragment, createRef, useState, useRef } from "react"
import {
    Label,
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Modal, 
    ModalBody, 
    ModalFooter, 
    ModalHeader,
    Badge
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { cancelToken } from '../../../../services/adapters/base'
import Select from '../../../../helpers/ui/CustomSelect'

import { Link, Redirect } from "react-router-dom"

import { AvForm, AvField } from "availity-reactstrap-validation"

import TableComponent from "./Components/TableComponent"

import DraftBloc from './Blocs/DraftBloc'

class DraftView extends Component {
    indexBloc = new DraftBloc();
    constructor(props) {
        super(props)
        this.state = {
            activeTab: "1",
            modal: false,
            list: [],
            eselon: [],
            draft: 0,
            filter: 
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: 20,
                    sort_order: {
                        column: 'work_unit_sort',
                        order: 'asc' 
                    }
                }
        }
        this.activeRef = createRef() 
    }
    reloadActiveRef = () => this.activeRef.current.setTokenAPI()

    submitData = async () => {
        await this.indexBloc.fetchSubmit({})
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false,
                    modal: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false,
                    modal: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true,
                    modal: false
                }
                break;
             case 'failed':
                forState = {
                    failed: false,
                    modal: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    handlerOnSubmit = () => {
        this.setState({
            confirm: true
        })
    }


    componentDidMount() {
        this.indexBloc.submitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })    
    }

    componentWillUnmount() {
        this.indexBloc.submitChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to="/master/struktur-organisasi.html" className="waves-effect" style={{ marginRight: 5 }}>
                                    <Button color="secondary">Kembali</Button>
                                </Link>
                                {
                                    (accessRole('approve')) &&
                                        <div className="waves-effect" style={{ marginRight: 5}}>
                                            <Button color="success" onClick={() => this.handlerOnSubmit()}>
                                                Submit
                                            </Button>
                                        </div>
                                }
                            </div>
                            <CardTitle>Draft Satuan Unit</CardTitle>
                            <CardSubtitle>List Draft Satuan Unit</CardSubtitle>
                            <hr />
                            <TableComponent ref={this.activeRef} handleInactiveSuccess={() => this.reloadActiveRef()}/>
                        </CardBody>
                    </Card>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/struktur-organisasi.html'/>
                : null }
            </Fragment>
        )
    }
}

export default DraftView